import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTick = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 9,
	viewBox: "0 0 11 9",
	width: 11,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m1.375 4.75 2.625 2.625 6-6",
		stroke: "#fff",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	})
});
export default SvgTick;
